module.exports = __webpack_public_path__ + "media/images/ads/creators_desktop-ec6dd9fd0fac991a17f7776471597651.png";